/**
 * 全局通用的
 */
import { CDN_HOST, UPLOAD_CDN_HOST } from '@/config/env'

export default {
  data() {
    return {
      // process: {
      //   env: process.env,
      //   APP: process.APP,
      //   BUILD: process.BUILD,
      // },
      // CDN_HOST: CDN_HOST[process.env.VUE_APP_SERVER_ENV], // CDN静态资源地址
      // UPLOAD_CDN_HOST: UPLOAD_CDN_HOST[process.env.VUE_APP_SERVER_ENV], // 商品图片CDN地址
    }
  },
  computed: {},
}
